import React from "react";
import { createRoot } from "react-dom/client";
import { MenuData, SiteTheme } from "../../types/types";
import Header from "./Header";

let menuData: MenuData;

const HeaderContainer = () => {
    const dataElement = document.getElementById("header-menu-items");
    if (dataElement) {
        const data = JSON.parse(dataElement.textContent || "{}");
        menuData = data;
    }

    const headerMenuContainer = document.querySelector(
        "#header-menu",
    ) as HTMLElement;
    const logoSrc = headerMenuContainer?.getAttribute("data-logo-src");
    const siteTheme = document
        .querySelector("body")
        ?.getAttribute("data-site") as SiteTheme;

    if (headerMenuContainer && menuData) {
        createRoot(headerMenuContainer).render(
            <Header
                logoSrc={logoSrc}
                menuItems={menuData.menuItems}
                searchPageUrl="/soksida/"
                siteTheme={siteTheme}
            />,
        );
        headerMenuContainer.style.display = "block";
    }
};

export default HeaderContainer;
